<template>
    <v-app>
        <v-main :class="currentRouteName">
            <v-container class="fill-height py-0" fluid>
                <v-row style="height: 100%;" class="registration-wrapper">
                    <v-col md="4" lg="3" cols="12" class="d-flex flex-column justify-space-between registration-left px-8">
                        <div class="registration-logo text-center py-6">
                            <v-img
                                transition="scale-transition"
                                src="../../assets/images/logo-white.png"
                                :max-width="this.$vuetify.breakpoint.smAndDown ? '150' : '250'"
                                class="ml-auto mr-auto"
                            ></v-img>
                        </div>
                        <div class="registration-info white--text text-center">
                            <span :class="this.$vuetify.breakpoint.smAndDown ? 'text-h4' : 'text-h2'" class="font-weight-light mb-4 d-block">
                                Welcome to Message IQ
                            </span>
                            <span :class="this.$vuetify.breakpoint.smAndDown ? 'body-2' : 'text-h5'" class="font-weight-thin d-block">
                                Click Rates on SMS are over 400% higher than email. With Message IQ, you can track performance of your SMS campaigns to optimize them just like you would your email campaigns.
                            </span>
                        </div>
                        <div></div>
                    </v-col>
                    <v-col cols="12" offset="0" md="6" offset-md="1" lg="7" offset-lg="1" class="d-flex flex-column justify-center registration-main">
                        <slot />
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: "MessageIqSignupLayout",
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    }
};
</script>
